<template>
  <b-row>
    <b-col cols="12">
      <div id="parentx">
        <transition name="slide">
          <b-card>
            <div slot="header">
              {{ $t('sidebar.reports.wholesale') }}
              <div class="card-header-actions"></div>
            </div>
            <b-card-body>
              <FilterPosReport
                @filter="filter"
                @changeType="changeType"
                @disableTab="disableTabMethod"
                :departments="myDepartments"
              ></FilterPosReport>

              <!-- <div v-if=" reportSearchable.length==1" class="animated fadeIn">
								<b-row v-if="reportSearchable.length>0" v-for="(item, index) in reportSearchable"
									   :key="index">
									<b-col sm="6" md="2">
										<b-card style="min-height: 0px">
											<div class="h1 text-muted text-right mb-4">
												<i class="fa fa-money"></i>
											</div>
											<div style="font-size: 14px;text-align: center" class="h4 mb-0">
												{{item.sum ?
												item.sum:0 |
												currency({symbol:
												userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'})}}
											</div>
											<small style="font-size: 9px;"
												   class="text-uppercase cardCustom font-weight-bold">Обшая
												сумма
											</small>
											<b-progress height={} class="progress-xs mt-3 mb-0" variant="info"
														:value="25"/>
										</b-card>
									</b-col>
									<b-col sm="6" md="2">
										<b-card style="min-height: 0px">
											<div class="h1 text-muted text-right mb-4">
												<i class="icon-speech"></i>
											</div>
											<div class="h4 mb-0" style="font-size: 14px;text-align: center">{{item.chek
												| currency({symbol:
												userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'})}}
											</div>
											<small style="font-size: 9px;"
												   class="text-uppercase cardCustom font-weight-bold">СРЕДНИЙ ЧЕК
											</small>
											<b-progress height={} class="progress-xs mt-3 mb-0" variant="success"
														:value="25"/>
										</b-card>
									</b-col>
									<b-col sm="6" md="2">
										<b-card style="min-height: 0px">
											<div class="h1 text-muted text-right mb-4">
												<i class="fa fa-money"></i>
											</div>
											<div class="h4 mb-0" style="font-size: 14px;text-align: center">
												{{item.sumAmountUzs
												| currency({symbol:
												userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'})}}
											</div>
											<small style="font-size: 9px;"
												   class="text-uppercase cardCustom font-weight-bold">CУММА
											</small>
											<b-progress height={} class="progress-xs mt-3 mb-0" variant="success"
														:value="25"/>
										</b-card>
									</b-col>
									<b-col sm="6" md="2">
										<b-card style="min-height: 0px">
											<div class="h1 text-muted text-right mb-4">
												<i class="fa fa-exchange"></i>
											</div>
											<div class="h4 mb-0" style="font-size: 14px;text-align: center">
												{{item.qtyTransactions ? item.qtyTransactions:0}}
											</div>
											<small style="font-size: 9px"
												   class="text-uppercase cardCustom font-weight-bold">КОЛ-ВО
												ТРАНЗАЦИИ
											</small>
											<b-progress height={} class="progress-xs mt-3 mb-0" variant="warning"
														:value="25"/>
										</b-card>
									</b-col>
									<b-col sm="6" md="2">
										<b-card style="min-height: 0px">
											<div class="h1 text-muted text-right mb-4">
												<i class="fa fa-product-hunt"></i>
											</div>
											<div class="h4 mb-0" style="font-size: 14px;text-align: center">
												{{item.qtyItems? item.qtyItems:0}}
											</div>
											<small style="font-size: 9px;"
												   class="text-uppercase cardCustom font-weight-bold">
												Кол-во
												товаров
											</small>
											<b-progress height={} class="progress-xs mt-3 mb-0" variant="info"
														:value="25"/>
										</b-card>
									</b-col>
									<b-col sm="6" md="2">
										<b-card style="min-height: 0px">
											<div class="h1 text-muted text-right mb-4">
												<i class="fa fa-money"></i>
											</div>
											<div class="h4 mb-0" style="font-size: 14px;text-align: center">
												{{item.skidka? item.skidka:0| currency({symbol:
												userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'})}}
											</div>
											<small style="font-size: 9px"
												   class="text-uppercase cardCustom font-weight-bold">
												Скидка
											</small>
											<b-progress height={} class="progress-xs mt-3 mb-0" :value="25"/>
										</b-card>
									</b-col>
									<b-col sm="6" md="2">
										<b-card style="min-height: 0px">
											<div class="h1 text-muted text-right mb-4">
												<i class="icon-speedometer"></i>
											</div>
											<div class="h4 mb-0" style="font-size: 14px;text-align: center">
												{{item.date}}
											</div>
											<small style="font-size: 9px;color: black"
												   class="text-uppercase cardCustom font-weight-bold">{{$t('incomes.date')}}
											</small>
											<b-progress height={} class="progress-xs mt-3 mb-0" variant="danger"
														:value="25"/>
										</b-card>
									</b-col>
								</b-row>


              </div>-->
            </b-card-body>
            <div class="row">
              <div
                class="table mt-1 generalTableClass col-12"
                v-for="(value, name,index) in reportSearchable"
              >
                <!--<div v-if="loader" class="spinner-wrapper">-->
                <!--<b-spinner variant="primary"></b-spinner>-->
                <!--</div>-->
                <div class="text-center">
                  <b>{{name}}</b>
                </div>
                <table style="width: 100%">
                  <thead>
                    <tr>
                      <!-- TOTAL INCOME SUM OF SALE_ITEMS -->
                      <th
                        v-if="disableTable!== 'byEmployee' && isAdmin"
                        class="alignedRight"
                        style="width: 12%"
                      >{{$t('money.incomeUzsTotal')}}</th>

                      <th
                        v-if="disableTable!== 'byEmployee'"
                        class="alignedRight"
                        style="width: 12%"
                      >{{$t('sale.sum-skidka')}}</th>
                      <th
                        v-if="disableTable!== 'byEmployee'"
                        class="alignedRight"
                        style="width: 11%"
                      >{{$t('sale.sum-sredniy')}}</th>
                      <th style="width: 12%" class="alignedCenter">{{$t('sale.sum-general')}}</th>
                      <th class="alignedRight" style="width: 7%">{{$t('sale.transaction')}}</th>
                      <th class="alignedRight" style="width: 7%">{{$t('sale.transaction-item')}}</th>
                      <!-- REFUND AMOUNTS -->
                      <th
					  v-if="disableTable!== 'byEmployee'"
                        class="alignedRight"
                        style="width: 7%"
                      >{{$t('sidebar.reports.refundCount')}}</th>
                      <th
					  v-if="disableTable!== 'byEmployee'"
                        class="alignedRight"
                        style="width: 10%"
                      >{{$t('sidebar.reports.refundAmount')}}</th>
                      <th
                        v-if="disableTable!== 'byEmployee'"
                        class="alignedRight"
                      >{{$t('client.create.memberCardDiscount')}}</th>
                      <th class="alignedRight" style="width: 12%">{{$t('incomes.date')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="value.length>=1" v-for="(item, index) in value" :key="index">
                      <!-- TOTAL INCOME SUM OF SALE_ITEMS -->
                      <td v-if="disableTable!== 'byEmployee' && isAdmin">
                        {{item.total_income_uzs_1 | currency({
                        symbol:
                        returnDepCurrencyName(name), fractionCount: 2, symbolPosition: 'back'
                        })}}
                      </td>

                      <td v-if="disableTable!== 'byEmployee'">
                        {{item.sumWithSkidka | currency({
                        symbol:
                        returnDepCurrencyName(name), fractionCount: 2, symbolPosition: 'back'
                        })}}
                      </td>
                      <td v-if="disableTable!== 'byEmployee'">
                        {{item.chek | currency({
                        symbol:
                        returnDepCurrencyName(name), fractionCount: 2, symbolPosition: 'back'
                        })}}
                      </td>
                      <!--<td>{{value[value.length-1].maxValue}}</td>-->
                      <td>
                        {{item.sum?item.sum:item.sumAmountUzs | currency({
                        symbol:
                        returnDepCurrencyName(name), fractionCount: 2, symbolPosition: 'back'
                        })}}
                      </td>
                      <td>{{item.qtyTransactions}}</td>
                      <td>{{item.qtyItems}}</td>
                      <!-- REFUND AMOUNTS -->
                      <td v-if="disableTable!== 'byEmployee'">{{ item.returnCount }}</td>
                      <td v-if="disableTable!== 'byEmployee'">
                        {{ item.returnSum | currency({
                        symbol:
                        returnDepCurrencyName(name), fractionCount: 2, symbolPosition: 'back'
                        })}}
                      </td>
                      <td v-if="disableTable!== 'byEmployee'" style="width: 15%">
                        {{item.skidka | currency({
                        symbol:
                        returnDepCurrencyName(name), fractionCount: 2, symbolPosition: 'back'
                        })}}
                      </td>
                      <td style="width: 15%">{{item.date}}</td>
                      <!--<td style="color: black">-->
                      <!--<b-progress>-->
                      <!--<b-progress-bar variant="success"-->
                      <!--:value="item.sumOfCount * 100 / totalMaxValue(value)"-->
                      <!--:label="`${(item.sumOfCount * 100 / totalMaxValue(value)).toFixed(0)}%`"-->
                      <!--show-progress-->
                      <!--:max="100"-->
                      <!--&gt;</b-progress-bar>-->
                      <!--</b-progress>-->
                      <!--</td>-->
                    </tr>
                    <tr v-if="value.length==0">
                      <td :colspan="disableTable !== 'byEmployee' ? 10 : 7" v-if="value.length==0">
                        <h4>{{$t('empty')}}</h4>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="value.length>=1">
                  <div v-if="value[0].sum" class="excel" style="padding-top: 2px">
                    <download-excel
                      size="sm"
                      class="btn btn-success"
                      :data="value"
                      :fields="json_fields"
                      worksheet="My Worksheet"
                      name="Excel"
                    ></download-excel>
                  </div>
                  <div v-if="value[0].sumAmountUzs" class="excel" style="padding-top: 2px">
                    <download-excel
                      size="sm"
                      class="btn btn-success"
                      :data="value"
                      :fields="json_fields1"
                      worksheet="My Worksheet"
                      name="Excel"
                    ></download-excel>
                  </div>
                </div>
              </div>
            </div>
            <!--<div v-if="reportSearchable.length>1">-->
            <!--<b-table class="generalTableClass" striped hover :items="reportSearchable"-->
            <!--:fields="computedField">-->

            <!--<template slot="id" slot-scope="data">-->
            <!--{{ data.index + 1 }}-->
            <!--</template>-->

            <!--<template slot="sumWithSkidka" slot-scope="data">-->
            <!--<span>{{data.item.sumWithSkidka | currency({symbol: 'Сум', symbolPosition: 'back'})-->
            <!--}}</span>-->
            <!--</template>-->

            <!--<template slot="chek" slot-scope="data">-->
            <!--<span>{{data.item.chek | currency({symbol: 'Сум', symbolPosition: 'back'})-->
            <!--}}</span>-->
            <!--</template>-->

            <!--<template slot="sumAmountUzs" slot-scope="data">-->
            <!--<span>{{data.item.sumAmountUzs | currency({symbol: 'Сум', symbolPosition: 'back'})-->
            <!--}}</span>-->
            <!--</template>-->

            <!--<template slot="skidka" slot-scope="data">-->
            <!--<span>{{data.item.skidka | currency({symbol: 'Сум', symbolPosition: 'back'})-->
            <!--}}</span>-->
            <!--</template>-->

            <!--<template slot="qtyTransactions" slot-scope="data">-->
            <!--<span>{{data.item.qtyTransactions?data.item.qtyTransactions:0}}</span>-->
            <!--</template>-->

            <!--<template slot="qtyItems" slot-scope="data">-->
            <!--<span>{{data.item.qtyItems?data.item.qtyItems:0}}</span>-->
            <!--</template>-->

            <!--</b-table>-->
            <!--</div>-->
            <!--<div v-for="(value, name) in reportSearchable">-->
            <!--{{ name }}: {{ value }}-->
            <!--<div>-->
            <!--<div class="excel">-->
            <!--<download-excel-->
            <!--size="sm"-->
            <!--class="btn btn-success"-->
            <!--:data="value"-->
            <!--:fields="json_fields"-->
            <!--worksheet="My Worksheet"-->
            <!--name="Excel">-->
            <!--</download-excel>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->

            <span
              style="display: flex;justify-content: center"
              v-if="reportSearchable.length==0"
            >{{$t('empty')}}</span>
          </b-card>
        </transition>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import FilterPosReport from "./blocks/Filter";

export default {
  name: "PosReport",

  data: () => {
    return {
      disableTable: "",
      json_fields: {
        "ОБШАЯ СУММА": "sumWithSkidka",
        "СРЕДНИЙ ЧЕК": "chek",
        СУММА: "sum",
        "КОЛ-ВО ТРАНЗАЦИИ": "qtyTransactions",
        "КОЛ-ВО ТОВАРОВ": "qtyItems",
        СКИДКА: "skidka",
        ДАТА: "date"
      },
      json_fields1: {
        "ОБШАЯ СУММА": "sumWithSkidka",
        "СРЕДНИЙ ЧЕК": "chek",
        СУММА: "sumAmountUzs",
        "КОЛ-ВО ТРАНЗАЦИИ": "qtyTransactions",
        "КОЛ-ВО ТОВАРОВ": "qtyItems",
        СКИДКА: "skidka",
        ДАТА: "date"
      },
      type: "daily",
      loader: true,
      items: {
        afterSaleSum: 0,
        saleSum: 0
      },
      message: "Cуточный Отчет",
      allEmployee: [],
      search: {
        page: 1,
        limit: 20,
        attributes: []
      },
      depsForCurrency: []
    };
  },

  /**
   * Computed
   */
  async created() {
    await this.getDailySum();
    await this.getMonthlySum();
    await this.setFilter();
  },
  computed: {
    ...mapState(['userDepCurrencyName', 'isAdmin']),
    computedField() {
      return [
        {
          key: "id",
          label: "№",
          sortable: true
        },
        {
          key: "sum",
          label: "ОБШАЯ СУММА",
          class: "min-150",
          visible: true
        },
        {
          key: "chek",
          label: "СРЕДНИЙ ЧЕК",
          class: "min-100",
          sortable: true,
          visible: true,
          changebale: true
        },
        {
          key: "sumAmountUzs",
          label: "CУММА",
          class: "min-100",
          sortable: true,
          visible: true,
          changebale: true
        },

        {
          key: "qtyTransactions",
          label: "КОЛ-ВО ТРАНЗАЦИИ",
          class: "min-60",
          sortable: true,
          visible: true,
          changebale: true
        },
        {
          key: "qtyItems",
          class: "min-80",
          label: "КОЛ-ВО ТОВАРОВ",
          sortable: true,
          visible: true,
          changebale: true
        },
        {
          key: "skidka",
          label: "СКИДКА",
          class: "min-100",
          sortable: true,
          visible: false,
          changebale: true
        },
        {
          key: "date",
          class: "min-150",
          label: "ДАТА",
          sortable: true,
          visible: true,
          changebale: true
        }
      ];
    },
    getSum() {
      if (this.reportSearchable) {
        return this.reportSearchable[0].sum;
      } else {
        return 0;
      }
    },
    ...mapGetters("departments", ["myDepartments"]),
    ...mapState("wholeSaleReport", ["reportSearchable"]),
    ...mapState(["userDepCurrencyName"]),
    ...mapGetters("wholeSaleReport", {
      total: "getTotal",
      daily: "getDaily",
      monthly: "getMonthly",
      refField: "getColums"
    }),

    ...mapGetters("wholeSaleReport", ["getByEmployee", "getInDateRange"])
  },

  methods: {
    disableTabMethod($event) {
      this.disableTable = $event;
    },
    ...mapActions("wholeSaleReport", [
      "getDailySum",
      "getMonthlySum",
      "getByEmployeeId",
      "getByDate",
      "searchReportStore"
    ]),
    returnDepCurrencyName(depName) {
      if (this.depsForCurrency.length > 0) {
        let tempDep = this.depsForCurrency.find(el => {
          return el.name == depName;
        });
        if (tempDep) {
          return tempDep.currencyName;
        } else {
          return this.userDepCurrencyName;
        }
      }
      return this.userDepCurrencyName;
    },
    changeType(type) {
      this.type = type;
    },
    filter($event) {
      this.disableTable = $event.sale;
      if ($event.type === "daily") {
        this.message = "Cуточный Отчет";
        this.setFilter("daily");
      }
      if ($event.type === "monthly") {
        this.message = "Месячный Отчет";
        this.setFilter("monthly");
      }
      if ($event.type === "byEmployee") {
        this.message =
          "Сотрудник" +
          " : " +
          $event.employeeId.firstName +
          " " +
          $event.employeeId.lastName;
        this.setFilter("byEmployee", $event);
      }
      if ($event.type === "inDateRange") {
        this.message = $event.fromDate + " - " + $event.toDate;
        this.setFilter("inDateRange", $event);
      }
      this.depsForCurrency = $event.depId;
      let depId = $event.depId.map(department => {
        return department.id;
      });
      if ($event.depId.length) {
        let obj = {};
        obj.depId = depId;
        if ($event.fromDate !== "") {
          obj.fromDate = $event.fromDate;
        } else {
          obj.fromDate = null;
        }
        if ($event.toDate !== "") {
          obj.toDate = $event.toDate;
        } else {
          obj.toDate = null;
        }
        obj.sale = $event.sale;
        obj.type = $event.type;
        if ($event.employeeId !== null) {
          obj.employeeId = $event.employeeId.id;
        }
        this.searchReportStore(obj);
      } else {
        this.$vs.notify({
          title: "Пожалуйста выберите Отдел",
          color: "warning",
          icon: "close",
          position: "top-right"
        });
      }
    },
    async setFilter(type = "daily", obj = null) {
      if (type === "daily") {
        this.items.afterSaleSum = this.daily.afterSaleSum
          ? this.daily.afterSaleSum
          : 0;
        this.items.saleSum = this.daily.saleSum ? this.daily.saleSum : 0;
      }

      if (type === "monthly") {
        this.items.afterSaleSum = this.monthly.afterSaleSum
          ? this.monthly.afterSaleSum
          : 0;
        this.items.saleSum = this.monthly.saleSum ? this.monthly.saleSum : 0;
      }

      if (type === "byEmployee") {
        let search = {
          sellerId: obj.employeeId.id
        };

        if (obj.start !== "" && obj.end !== "") {
          search.fromDate = obj.start;
          search.toDate = obj.end;
          await this.getByDate(search);
          let bydate = this.getInDateRange;
          this.items.afterSaleSum = bydate.afterSaleSum
            ? bydate.afterSaleSum
            : 0;
          this.items.saleSum = bydate.saleSum ? bydate.saleSum : 0;
        } else {
          await this.getByEmployeeId(obj.employeeId.id);
          let byemp = this.getByEmployee;
          this.items.afterSaleSum = byemp.afterSaleSum ? byemp.afterSaleSum : 0;
          this.items.saleSum = byemp.saleSum ? byemp.saleSum : 0;
        }
      }

      if (type === "inDateRange") {
        let search = {
          fromDate: obj.start,
          toDate: obj.end,
          sellerId: ""
        };
        await this.getByDate(search);
        let test = this.getInDateRange;
        this.items.afterSaleSum = test.afterSaleSum ? test.afterSaleSum : 0;
        this.items.saleSum = test.saleSum ? test.saleSum : 0;
      }
    }
  },

  mounted() {},
  beforeDestroy() {
    this.$store.commit("wholeSaleReport/resetReportSearch", []);
  },

  watch: {},
  /**
   * components
   */
  components: {
    FilterPosReport
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
.table-wrapper {
  position: relative;
  padding: 5px;
}
.table {
  table {
    th,
    td {
      text-align: center;
    }
  }
}
.spinner-wrapper {
  position: absolute;
  background: rgba(32, 28, 32, 0.49);
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  padding-top: 35px;
  z-index: 5;
}

.cardCustom {
  display: flex;
  justify-content: center;
}

.excel {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 5px;
}
</style>
